import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Github, Globe, Info, ExternalLink, Link as LinkIcon } from 'lucide-react';
import projectData from '../data/projectLinks.json';

const LinksPage = () => {
  const { slug } = useParams();
  const project = projectData[slug];

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", localStorage.getItem("theme") || "dark");
  }, []);

  const getIcon = (type) => {
    const iconProps = { size: 18, strokeWidth: 2.5 };
    switch (type) {
      case 'github': return <Github {...iconProps} />;
      case 'website': return <Globe {...iconProps} />;
      case 'info': return <Info {...iconProps} />;
      default: return <LinkIcon {...iconProps} />;
    }
  };

  if (!project) {
    return (
      <div className="lp">
        <h1 className="lp-title">404</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '16px', margin: 0 }}>Project not found</p>
      </div>
    );
  }

  return (
    <div className="lp">
      <h1 className="lp-title">{project.title}</h1>
      <div className="lp-links">
        {project.links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target={link.url.startsWith('/') ? undefined : "_blank"}
              rel={link.url.startsWith('/') ? undefined : "noopener noreferrer"}
              className="lp-link"
              style={{ animationDelay: `${index * 0.12 + 0.2}s` }}
              onClick={(e) => { if (link.url === '#') e.preventDefault(); }}
            >
            <div className="lp-icon">
              {getIcon(link.type)}
            </div>
            <span className="lp-label">{link.label}</span>
            <div className="lp-arrow">
              <ExternalLink size={16} />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default LinksPage;
